import { GetStaticProps } from 'next';
import { getAllPosts } from '../../lib/posts';
import { Key, ReactChild, ReactFragment, ReactPortal } from 'react';
import { formatDate } from '@/lib/blog_utils';
import Link from 'next/link';
import Layout from '@/components/Layout';
import { NextSeo } from 'next-seo';
import { authors } from '../../lib/authors';

export default function BlogIndex({ posts }: { posts: any }) {
  return (
    <>
      <NextSeo
        title="Mendable Blog: AI for Technical Resources"
        description="Get all your Mendbale News the Mendable blog."
        openGraph={{
          title: 'Mendable Blog: AI for Technical Resources',
          description: 'Get all your Mendbale News the Mendable blog.',
          images: [
            {
              url: 'https://www.mendable.ai/mendable_new_og1.png',
              width: 800,
              height: 600,
              alt: 'Mendable Blog: AI for Technical Resources'
            }
          ]
        }}
      />
      <section className="relative mt-40 text-white h-full">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 p-4 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {posts.map(
              (
                post: {
                  slug: string;
                  title: string;
                  date: string;
                  featuredImage: string;
                  subheadline: string;
                  author: string;
                },
                index: number
              ) => (
                <div
                  key={post.slug}
                  className={`mb-5 text-start rounded-md ${
                    index === 0
                      ? 'lg:col-span-3 lg:flex lg:items-center  lg:mb-8'
                      : ''
                  }`}
                >
                  {' '}
                  {/* Apply flex for the first item */}
                  <Link href={`/blog/${post.slug}`}>
                    <a
                      className={`lg:flex lg:items-center  rounded-md group " ${
                        index === 0 ? 'lg:flex-row ' : 'lg:flex-col lg:!items-start'
                      }`}
                    >
                      {' '}
                      {/* Create flex container for the content inside the anchor tag */}
                      <div className='overflow-hidden rounded-md'>
                      <img
                        src={post.featuredImage}
                        className={`mx-auto rounded-md mb-3 group-hover:scale-105 transition-all border-slate-300 ${
                          index === 0 ? 'lg:max-w-[775px] lg:mb-0' : ''
                        }`}
                        alt={post.title}
                      />
                      </div>
                      {index === 0 ? (
                        <div className="lg:ml-8 lg:max-w-1/2 self-center">
                          {' '}
                          {/* Create a div to hold the text and apply styles to create space and restrict width */}
                          <p className="text-gray-300 text-sm hidden lg:flex mb-3">
                            {formatDate(post.date)}
                          </p>
                          <h2 className="text-2xl lg:text-4xl font-semibold max-w-lg">
                            {post.title}
                          </h2>
                          <p className="mt-1 sm:mt-2 text-base font-normal max-w-sm text-gray-300">
                            {post.subheadline}
                          </p>
                          <div
                             
                              className="mt-5 flex justify-start items-center rounded-lg"
                            >
                              <span className="mr-2 relative block flex-shrink-0 overflow-hidden rounded-full">
                                <img
                                  src={authors[post.author].img}
                                  className="border border-primary border-opacity-50 rounded-full"
                                  alt={authors[post.author].name + ' image'}
                                  width="28"
                                  height="28"
                                />
                              </span>
                              <span className="text-gray-100 ">
                                {authors[post.author].name}
                              </span>
                              <p className="flex lg:hidden mx-2 text-xs sm:text-sm text-gray-300 ">
                              •
                            </p>
                            <p className="text-gray-400 text-sm flex lg:hidden">
                              {formatDate(post.date)}
                            </p>
                            </div>
                        </div>
                      ) : (
                        <>
                          <h2 className="text-2xl font-semibold">
                            {post.title}
                          </h2>
                          <p className="mt-1 sm:mt-2 text-base font-normal text-gray-300">
                            {post.subheadline}
                          </p>
                          <div className="mt-2 sm:mt-4 flex justify-start items-center">
                            <div
                              className="flex justify-start items-center rounded-lg"
                            >
                              <span className="mr-2 relative block flex-shrink-0 overflow-hidden rounded-full">
                                <img
                                  src={authors[post.author].img}
                                  className="border border-primary border-opacity-50 rounded-full"
                                  alt={authors[post.author].name + ' image'}
                                  width="28"
                                  height="28"
                                />
                              </span>
                              <span className="text-gray-100 ">
                                {authors[post.author].name}
                              </span>
                            </div>
                            <p className="mx-2 text-xs sm:text-sm text-gray-300 ">
                              •
                            </p>
                            <p className="text-gray-400 text-sm">
                              {formatDate(post.date)}
                            </p>
                          </div>
                        </>
                      )}
                    </a>
                  </Link>
                </div>
              )
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  const posts = getAllPosts([
    'title',
    'date',
    'slug',
    'featuredImage',
    'subheadline',
    'author'
  ]);

  return {
    props: { posts }
  };
};
